import { useEffect, useState } from 'react';
import { FeedbackDialog } from './FeedbackDialog';
import { installErrorRecorder } from './diagnostics';
import { useHotkeys } from '../layout/shortcuts';
import { IconButton } from '../design/primitives/Button';
import { Tooltip } from '../design/primitives/Overlay';

// One always-there way to report a problem, rendered in the top-bar of every skin next to the
// theme toggle as a "?" (help) icon — so it never collides with the Nova assistant (which floats
// bottom-right). It also starts the error recorder, so a report filed after something blew up
// carries the stack that blew up. `mod+shift+f` opens the same dialog from the keyboard, and the
// ⌘K command presses this button via its `.hf-feedback-btn` class.
export function FeedbackButton() {
  const [open, setOpen] = useState(false);
  useEffect(() => installErrorRecorder(), []);
  useHotkeys([{ keys: 'mod+shift+f', run: () => setOpen(true), label: 'Report feedback', group: 'General', global: true }]);

  return (
    <>
      <Tooltip content="Help & feedback" kbd="⌘⇧F">
        <IconButton
          icon="help-circle"
          label="Help & feedback"
          size="sm"
          className="hf-feedback-btn"
          onClick={() => setOpen(true)}
        />
      </Tooltip>
      <FeedbackDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
